import {
    Component,
    Inject,
    Input,
    OnInit,
    OnDestroy
} from '@angular/core';

import { BehaviorSubject, Observable, timer } from 'rxjs';
import { map, switchMap, scan } from 'rxjs/operators';

import { TOAST_DATA } from '../toastr.service';
import { ToastRef } from '../toast-ref';

@Component({
    selector: 'app-toast-transfering-pixel',
    templateUrl: './toast-transfering-pixel.component.pug',
    styleUrls: ['./toast-transfering-pixel.component.less'],
})
export class ToastTransferingPixelComponent implements OnDestroy, OnInit {
    _transferedSbj: BehaviorSubject<number> = new BehaviorSubject(0);
    transfered$: Observable<number> = this._transferedSbj.asObservable();
    @Input() set transfered(transfered: number) {
        this._transferedSbj.next(transfered || 0);
    }
    get transfered(): number {
        return this._transferedSbj.getValue();
    }

    _transferingSbj: BehaviorSubject<number> = new BehaviorSubject(null);
    transfering$: Observable<number> = this._transferingSbj.asObservable();
    @Input() set transfering(transfering: number) {
        this._transferingSbj.next(transfering || 0);
    }
    get transfering(): number {
        return this._transferingSbj.getValue();
    }

    @Input() duration = 100000;
    progress$ = this.transfering$
        .pipe(scan((acc) => [...acc, new Date() .getTime()], []))
        .pipe(switchMap((values) => timer(0, 1).pipe(map(() => values))))
        .pipe(map((values) => {
            const now = new Date() .getTime();
            const length = values.length;

            // console.log(this.duration);
            return values.map((start) => progressLog10((now - start), this.duration) / length);
        }))
        .pipe(map((values) => values.reduce((x, y) => x + y, 0)))
        .pipe(map((value) => `${ value > 100 ? 100 : value }%`));

    constructor(
        private _toastRef: ToastRef<ToastTransferingPixelComponent>,

        @Inject(TOAST_DATA) public data: any
    ) {
        this.transfered = data.transfered;
        this.transfering = data.transfering;
        this.duration = data.duration;
    }

    ngOnInit() {
    }

    ngOnDestroy() {
    }

    onStop() {
        this._toastRef.close(false);
    }
}

// Max progress value is 100
const PROGRESS_MULTIPLE = 50;
function progressLog10(cur, max) {
    if (cur > max) {
        return 100;
    }

    const x = 100 * cur / max;

    return Math.max(Math.round(PROGRESS_MULTIPLE * Math.log10(x)), 0);
}
